<script>
  import Navbar from "./Components/Navbar.svelte";
  import Banner from "./Components/Banner.svelte";
  import Services from "./Components/Services.svelte";
  import About from "./Components/About.svelte";
  import Quote from "./Components/Quote.svelte";
  import Footer from "./Components/Footer.svelte";
  import DATA from "./Data/data";
	import Decor from './Components/Decor.svelte';
</script>
<Navbar navlists={DATA.NAVBAR_DATA} />
<Banner bannerData={DATA.BANNER_DATA} />
<Services serviceData={DATA.SERVICE_DATA} />
<About aboutData={DATA.ABOUT_DATA} />
<Quote quoteData={DATA.QUOTE_DATA} />
<Footer footerData={DATA.FOOTER_DATA} header={DATA.HEADER} />

